/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from 'react';
import PldRelevanteModal  from "./PldRelevanteModal";
import PldModalForm from "./PldModalForms";
import * as API from '../../http/api';
import { closelightbox } from '../../util/Functions';
import { Button, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { openlightbox } from "../../util/Functions";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const PldModal = (props) => {
  const [zPos, setZPos] = useState(45)
  const [customer,setCustomer] = useState({
    "uuid":"",
    "numero_cuenta_proyecto":"",
    "cuenta_asociada_institucion":"",
    "nombre_apoderado" : "",
    "apellido_paterno_apoderado" : "",
    "apellido_materno_apoderado" : "",
    "domicilio": {
      "entidad_federativa": "",
      "calle": "",
      "colonia": "",
      "ciudad_poblacion": "",
      "codigo_postal": ""
    }
  })
 
  var [hasTrxOp,setHasTrxOp] = useState(false);
  const [tx, setTx] = useState({});
  const PERSONA_MORAL = "3";
  const [openModal, setOpenModal] = useState(false);
  const [reports, setReports] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [report, setReport] = useState('');
  const [trxUdade,settrxUdate] = useState('')
  var [customerType,setCustomerType] = useState("")
  const [fullname,setFullName] = useState("")
  const [country,setCountry] = useState("")
  //Defaul STP
  const [banckId,setBanckId] = useState("90646");
  const [amountTrx,setAmountTrx]= useState(0)
  //Defaul Mexico
  const [currency,setCurrency]= useState("MXN")
  const [customerInfo,setCustomerInfo] = useState({
    gname:"", taxid:"", curp_cliente:"", populationid:"", lname:"", slname:"", bdate:"", gender:"", bstate:""
  })
  const [invoicingCustomer, setInvoicingCustomer] = useState({
    country: "", extnum: "", intnum: "", locality: "", reference: "", state: "", street: "", town: "", zip: ""
  })
  
  useEffect(()  => {
    if(props.data && props.customer){
      getCustomer(true);
    }else{
      getCustomer(false);
    }
  }, []);

  const changeReport = (e) => {
    setReport(e.target.value);
    if(e.target.value){
      setDisabled(false);
    }else{
      setDisabled(true);
    }
  }

  const getCustomer = async (hasTrx)=>{
    props.changeLoader(true);
    setZPos(-1)
    setHasTrxOp(hasTrx)

    let data = {
      data: {
        customer: {
          keyword: props.customer.uuid
        },
        filters: {
          results_per_page: 50,
          page_number: 1,
          search_type: "uuid"
        }
      }
    }

    let request = await API.service('dataPersonal', data, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        let customerAddress = request.data.data.widget[1];
        let customerInfo = request.data.data.widget[0];
        let invoicing = customerAddress.content.address.invoicing;
        setFullName(customerInfo.content.name)
        props.catalogs.country.find(ele=>{
          if(ele.k === customerInfo.content.bcountry){
            setCountry(ele.v)
          }
        })
        setCustomerType(customerInfo.content.originAppUUID)
        customerType = customerInfo.content.originAppUUID;
        setInvoicingCustomer(invoicing);
        setCustomerInfo({
          gname:customerInfo.content.gname,
          taxid:customerInfo.content.taxid,
          curp_cliente:customerInfo.content.taxid,
          populationid:customerInfo.content.populationid,
          lname:customerInfo.content.lname,
          slname:customerInfo.content.slname,
          bdate:customerInfo.content.bdate,
          gender:customerInfo.content.gender,
          bstate:customerInfo.content.bstate
        })
        
        getAdrressByCp(invoicing.zip).then(resp=>{
          let codigoPostal:any = resp;
          let ent_fed = {
            k:"",
            v:""
          };
          props.catalogs.states.forEach(ele=>{
            if(ele.k === invoicing.state){
              ent_fed = ele;
            }
          })
          
          setCustomer({
            "uuid":props.customer.uuid,
            "numero_cuenta_proyecto":"",
            "cuenta_asociada_institucion":"",
            "nombre_apoderado" : "",
            "apellido_paterno_apoderado" : "",
            "apellido_materno_apoderado" : "",
            "domicilio": {
              "entidad_federativa":ent_fed.k,
              "calle": invoicing.street,
              "colonia":"",
              "ciudad_poblacion": codigoPostal?.clave_municipio,
              "codigo_postal": invoicing.zip 
            }
          })
        })
        
        if(hasTrx){   
          props.changeLoader(false);
          setZPos(45)       
          openModalPld(props.data,hasTrx);
          setAmountTrx(props.data.amount)
          setCurrency(props.data.currency)
          settrxUdate(props.data.udate)
          if(props.data.remote_account){
            if(props.data.remote_account.bank_id){
              setBanckId(props.data.remote_account.bank_id);
            }
          }
        }else{
          props.changeLoader(false);
          setZPos(45)   
          openModalPld({},hasTrx);
        }
      }
    }
    props.changeLoader(false);
    setZPos(45)
  }
  
  const openModalPld = async (item,hasTrx) => {
    setTx(JSON.parse(JSON.stringify(item)));
    props.changeLoader(true);
    setZPos(-1)
    let request = await API.service('openModalPld', {}, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        if(request.data.data.widget[0].type == 'modalPld'){
          if(request.data.data.widget[0].content.catalog){
            setOpenModal(true);
            let listPldForms:any = [];
            request.data.data.widget[0].content.catalog.forEach(formulario=>{   
              if(customerType != PERSONA_MORAL  && hasTrx){
                if(formulario.name === "personaFisicaConTrxInusual" || formulario.name === "personaFisicaConTrxInusualPM" || formulario.name ==="personaFisicaConTrxInterna" || formulario.name ==="personaFisicaConTrxInternaPM"){
                  listPldForms.push(formulario)
                }
              }else if(customerType != PERSONA_MORAL  && !hasTrx){
                if(formulario.name === "personaFisicaSinTrxInusual" || formulario.name ==="personaFisicaSinTrxInterna"){
                  listPldForms.push(formulario);
                  let hasRelevante = listPldForms.find(ele => ele.uuid === "relevante")                  
                  if(hasRelevante === undefined){
                    listPldForms.push({
                      uuid:"relevante",
                      label:"Relevante"
                    })
                  }
                }
              }else if(customerType === PERSONA_MORAL  && hasTrx){
                if(formulario.name === "personaMoralContrxInusual" || formulario.name ===  "personaMoralContrxInusualPM"){
                  listPldForms.push(formulario)
                }
              }else if(customerType === PERSONA_MORAL  && !hasTrx){
                if(formulario.name === "personaMoralSintrxInusual"){
                  listPldForms.push(formulario)
                  listPldForms.push({
                    uuid:"relevante",
                    label:"Relevante"
                  })
                }
              }
            })
            setReports(JSON.parse(JSON.stringify(listPldForms)))
          }
        }
      }
    }
    props.changeLoader(false);
    setZPos(45)
  }

  const getAdrressByCp = async (cp)=>{
    props.changeLoader(true);
    setZPos(-1)
    return await codigoPostalRequest(cp)
  }

  const codigoPostalRequest = async (cp)=>{
      props.changeLoader(true);
      setZPos(-1)
      let request = await API.service('codigoPostal', cp, props.pos, props.changeAlert, props.changeLoader, props.history);    
      if (request.status == 200) {
          if (request.data.data.response == 'OK') {
            props.changeLoader(false);
            setZPos(45)
            return request.data.data.widget[0].content[0];
          }else{
            props.changeLoader(false);
            setZPos(45)
            return {}
          }
      }
  }

  const dateFormate = (date)=>{
    if(date != null && date != ""){
      return new Date(date).toISOString();
    }else{
      return "";
    }
  }
  
  //Pré llenado del formulario
  const loadingForm = (form)=>{
    for(let i = 0; i<form.length; i++){
      if(form[i]['findValue']){
        let find = form[i]['findValue'].split('.');
        let value = tx;
        for(let j = 0; j<find.length; j++){
          if(value.hasOwnProperty(find[j])){
            value = value[find[j]];
          }
        }
        if(form[i]['findValue'].split('.')[0] === "calle_domicilio"){
          form[i]['value'] = customer.domicilio.calle
        }
        if(form[i]['findValue'].split('.')[0] === "colonia"){
          getAdrressByCp(customer.domicilio.codigo_postal).then(resp=>{
            let coloniasAux =[];
            let codigoPostal:any = resp;
            if(codigoPostal != undefined){
              codigoPostal.colonias.map(col =>{
                coloniasAux.push({
                  "key" :col.clave,
                  "label":col.nombre
                })
              })
              form[i]['values'] = coloniasAux;
            }
          })
        }
        if(form[i]['findValue'].split('.')[0] === "ciudad_poblacion"){
          let dcp = customer.domicilio.ciudad_poblacion;
          getAdrressByCp(customer.domicilio.codigo_postal).then(resp=>{
            let codigoPostal:any = resp;
            if(codigoPostal != undefined){
              if(codigoPostal.nombre_municipio){
                dcp = codigoPostal.nombre_municipio
              }
              form[i]['value'] = dcp
            }
          })
        }
        if(form[i]['findValue'].split('.')[0] === "codigo_postal"){
          form[i]['value'] = customer.domicilio.codigo_postal
        }
        if(form[i]['findValue'].split('.')[0] === "entidad_federativa_domicilio"){
          let ent_fed = {
            k:"",
            v:""
          };
          props.catalogs.states.forEach(ele=>{
            if(ele.k === customer.domicilio.entidad_federativa){
              ent_fed = ele;
            }
          })
          form[i]['value'] = ent_fed.v
        }
        if(form[i]['findValue'].split('.')[0] === "fecha_deteccion"){
          form[i]['value'] = dateFormate ( Date.now());
        }
        if(form[i]['findValue'].split('.')[0] === "fecha"){
          form[i]['value'] = trxUdade;
        }
        if(form[i]['findValue'].split('.')[0] === "fecha_operacion"){
          if(trxUdade != ""){
            form[i]['value'] = trxUdade;
          }
        }
        if(form[i]['findValue'].split('.')[0] === "fecha_fin_perfil"){
          if(trxUdade != ""){
            form[i]['value'] = trxUdade;
          }
        }
        if(form[i]['findValue'].split('.')[0] === "nacionalidad_cuenta_contraparte"){
          form[i]['value'] = "Mexicana";
        }
        if(form[i]['findValue'].split('.')[0] === "uuid_cliente"){
          form[i]['value'] = props.customer.uuid;
        }
        if(form[i]['findValue'].split('.')[0] === "entidad_nacimiento"){
          form[i]['value'] = customerInfo.bstate;
        }
        if(form[i]['findValue'].split('.')[0] === "genero"){
          form[i]['value'] = customerInfo.gender;   
        }
        if(form[i]['findValue'].split('.')[0] === "nombre"){
          form[i]['value'] = customerInfo.gname;
        }
        if(form[i]['findValue'].split('.')[0] === "rfc"){
          form[i]['value'] = customerInfo.taxid;                 
        }
        if(form[i]['findValue'].split('.')[0] === "curp"){
          form[i]['value'] = customerInfo.populationid;
        }
        if(form[i]['findValue'].split('.')[0] === "apellido_paterno"){
          form[i]['value'] = customerInfo.lname;   
        }
        if(form[i]['findValue'].split('.')[0] === "apellido_materno"){
          form[i]['value'] = customerInfo.slname;
        }
        if(form[i]['findValue'].split('.')[0] === "fecha_nacimiento"){
          form[i]['value'] = customerInfo.bdate; 
        }
        if(form[i]['findValue'].split('.')[0] === "pais_nacionalidad"){ 
          form[i]['value'] = invoicingCustomer.country;
        }
        if(form[i]['findValue'].split('.')[0] === "monto" && form[i]['value'].length === 0 ){
          form[i]['value'] = Math.abs(amountTrx).toString();
        }
        if(form[i]['findValue'].split('.')[0] === "moneda" && form[i]['value'].length === 0){
          form[i]['value'] = currency;
        }
        if(form[i]['findValue'].split('.')[0] === "institucion_financiera_contraparte"){
          form[i]['value'] = banckId;
        }
        if(form[i]['type'] == 'select' && form[i]['catalog']){
          form[i]['values'] = props.catalogs[form[i]['catalog']];
        }
      }
    }
    return form;
  }
    
  const openModalPldForm = async () => {
    setOpenModal(false);
    props.changeAlert(false, '', '');
    props.changeLoader(true);
    setZPos(-1)
    let data = {
      report: report
    }
    
    if(report === "relevante"){
      props.changeLoader(false);
      setZPos(45)
      const as = (
        <PldRelevanteModal
        pos={props.pos}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        customerUuid={props.customer.uuid}/>);
        openlightbox(as);
      return;
    }
      
    let request = await API.service('openModalPldForm', data, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == 'OK') {
        setReport('');
        setDisabled(true);
        if(request.data.data.widget[0].type == 'modalPldForm'){
          if(request.data.data.widget[0].content.fields && request.data.data.widget[0].content.fields.length > 0){
            let form = loadingForm(request.data.data.widget[0].content.fields);
            let uuid = ""
            if(hasTrxOp){
              uuid = props.data.uuid
            }
            let sendData = {
              form :JSON.parse(JSON.stringify(form)),
              titleForm: request.data.data.widget[0].content.label,
              fullname: fullname,
              country: country,
              invoicingCustomer:invoicingCustomer,
              trxUdade:trxUdade, 
              hasTrxOp:hasTrxOp,
              customer:customer,
              trxUuid:uuid,
              spaceUuid:props.spaceUuid,
              formType:request.data.data.widget[0].content.name
            }
            const as = (
              <PldModalForm
              pos={props.pos}
              data={sendData}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              states ={props.catalogs.states}
              customerUuid={props.customer.uuid}/>);
            openlightbox(as);
          }
        }
      }else{
        setOpenModal(true);
      }
      props.changeLoader(false);
      setZPos(45)
    }
  }
  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          Seleccione una opción
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent >
          <FormControl variant="standard" fullWidth>
            <InputLabel id="label-pld">Tipo de Reporte</InputLabel>
            <Select labelId="label-pld" value={report} onChange={changeReport.bind(this)}>
              {reports.map((item, index) => {
                return <MenuItem value={item.uuid} key={`select-pld-${index}`}>{item.label}</MenuItem>
              })}
            </Select>
          </FormControl>
        </DialogContent>

        <DialogActions>
          <Button variant="contained"  disabled={disabled} onClick={openModalPldForm.bind(this)}>Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog> 
  )
}  
export default PldModal;